import _ from "lodash";
import { ContentSwitcher as CarbonContentSwitcher, FormLabel, Switch } from "carbon-components-react";

const ContentSwitcher = (props) => {
  const selectedIndex = () => {
    return props.selectedIndex - props.firstIndex;
  };

  const onChange = (e, name) => {
    const value = e.index + props.firstIndex;
    props.onChange(value, name);
  };

  const formLabel = (props.labelText) ? (
    <FormLabel>{props.labelText}</FormLabel>
  ) : null

  return (
    <>
      {formLabel}
      <CarbonContentSwitcher
        onChange={(e) => onChange(e, props.id)}
        selectedIndex={selectedIndex()}
      >
        {props.items.map((item, index) => {
          return (
            <Switch
              index={item.id}
              name={item.label}
              text={item.label}
              key={_.kebabCase(props.id) + index}
            />
          );
        })}
      </CarbonContentSwitcher>
    </>
  );
};

export default ContentSwitcher